import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { ROTATE_CODEX_SECRET } from '@/graphql/mutations/connections';

type UseRotateCodexSecretResult = { rotateCodexSecret: () => Promise<void>; isRotating: boolean };

export function useRotateCodexSecret(): UseRotateCodexSecretResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(ROTATE_CODEX_SECRET);

  const rotateCodexSecret = useCallback(async () => {
    await mutate();
    await refreshViewer();
  }, [mutate, refreshViewer]);

  return { rotateCodexSecret, isRotating: loading };
}
